<template>
    <div class="mx-auto col-lg-6 col-md-8 col-sm-12 header-margin pt-4">
        <!-- タイトル -->
        <div class="text-center text-message">
            <h3>{{ $t('hec.complete.title') }}</h3>
        </div>

        <div class="custom">
            <p class="text">
                <!-- メッセージ -->
                <div v-if="(this.address_status === 'obtained' || this.address_status === 'invalid') &&  ready">
                    <span v-html="$t('hec.complete.errormessage')"></span><br/>
                </div>
                <div v-else-if="!(this.address_status === 'obtained' || this.address_status === 'invalid') && ready">
                    <span v-html="$t('hec.complete.message')"></span><br/>
                </div>

                <!-- オーダーID -->
                <span class="order">{{ $t('hec.complete.custom') }}{{ custom_id }}</span>
            </p>
        </div>
        <!-- エラーメッセージ -->
        <div v-if="this.address_status === 'obtained' && ready">
            <div class="text-center text-errorMessage" v-html="$t('hec.complete.errorMessage1')"></div>
        </div>
        <div v-else-if="this.address_status === 'invalid' && ready">
            <div class="text-center text-errorMessage" v-html="$t('hec.complete.errorMessage2')"></div>
        </div>

        <!-- コピーボタン -->
        <div class="form-row py-3 justify-content-center">
            <div class="col-md-4">
                <span class="btn btn-light btn-block" @click="writeToClipboard( custom_id )">{{ $t('hec.complete.copyButton') }}</span>
            </div>
        </div>

        <div class="wrap">
            <p class="text">
                <!-- Rokes契約 -->
                <span v-html="$t('hec.complete.messageRokes')"></span><br/>
            </p>
        </div>

        <div class="wrap">
            <p class="text">
                <!-- 注意事項 -->
                <span>{{ $t('hec.complete.notes') }}</span><br/>
                <span>{{ $t('hec.complete.notesMessage1') }}</span><br/>
                <span>{{ $t('hec.complete.notesMessage2') }}</span><br/>
                <span>{{ $t('hec.complete.notesMessage3') }}</span>
            </p>
        </div>

    </div>
</template>

<script>
    import CoinpaymentsService from '../../services/CoinpaymentsService'
  
    export default {
        name: 'MembershipFeecomplete',

        components: {
        },

        data() {
            return {
                custom_id: '',//申込番号(英数32文字)
                ready: false,
                address_status: '',
                button: '',
            }
        },

        async created() {
            
        },

        mounted() {
            this.getCustomId()
        },

        methods: {
            //申込番号
            async getCustomId() {
                const getCoinpaymentsPayInfoData = (await CoinpaymentsService.getCoinpaymentsPayInfoData()).data;
                if(getCoinpaymentsPayInfoData) {
                    if(getCoinpaymentsPayInfoData.custom  == null){
                        this.address_status = 'obtained';
                        this.custom_id = '';
                        this.button = 'disabled';
                    }else if(getCoinpaymentsPayInfoData.custom == 0){
                        this.address_status = 'invalid';
                        this.custom_id = '';
                        this.button = 'disabled';
                    }else{
                        this.custom_id = getCoinpaymentsPayInfoData.custom;
                    }
                }else{
                    this.address_status = 'obtained';
                    this.custom_id = '';
                    this.button = 'disabled';
                }
                this.ready = true;
            },
            writeToClipboard(custom_id) {
                if(!(this.button == 'disabled')){
                    navigator.clipboard.writeText(custom_id).catch((e) => {
                        console.error(e)
                    })
                }
            },
        }
    }
</script>

<style scoped>
    .text-message {
        margin: 20px 0px;
    }
    .text-errorMessage{
        margin-top: 20px;
        color: #e3342f;
    }
    .frex-area {
        display: flex;
        flex-direction: column;
        align-items: center;
        padding-top: 10px;
    }
    .frex-area div {
        width: 380px;
    }
    .contents {
        padding-top: 10px;
        text-align: center;
    }
    .custom {
        margin: 16px auto 0px;
        text-align: center;
        display: block;
    }
    .custom .text {
        text-align: left;
        display: inline-block;
    }
    .wrap {
        margin: 16px auto;
        text-align: center;
        display: block;
    }
    .wrap .text {
        text-align: left;
        display: inline-block;
    }
    .order {
        line-height: 5.5;
    }
    .btn:hover {
        color: #fff !important;
    }
    @media screen and (max-width: 376px) {
        .order {
            line-height: 2.5;
        }
    }
    @media screen and (max-width: 390px) {
        .frex-area div {
            width: 290px;
        }
    }
</style>